import { Reveal } from "./Reveal";

export const Marquee = () => {
  const words = ["Ясность", "Ориентир", "Опора", "Наблюдение", "Согласие с собой"];
  const row = [...words, ...words, ...words, ...words];
  return (
    <section data-testid="marquee-section" className="border-y border-charcoal/10 py-8 md:py-10">
      <div className="relative flex overflow-hidden">
        <div className="flex shrink-0 animate-marquee items-center whitespace-nowrap">
          {row.map((w, i) => (
            <span key={i} className="flex items-center">
              <span className="px-8 font-serif text-3xl italic text-charcoal/70 md:text-5xl">
                {w}
              </span>
              <span className="text-sand">✦</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Introduction = () => (
  <section data-testid="introduction-section" className="mx-auto max-w-[1240px] px-6 py-28 md:px-10 md:py-40">
    <div className="grid gap-12 md:grid-cols-[0.9fr_1.1fr] md:gap-20">
      <Reveal>
        <span className="font-serif text-7xl italic text-sand md:text-8xl">01</span>
      </Reveal>
      <div>
        <Reveal>
          <h2 className="max-w-xl font-serif text-[1.8rem] leading-[1.08] tracking-tight text-charcoal sm:text-[2.4rem]">
            Иногда нам не нужен новый путь. Нам нужно лучше увидеть свой.
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="mt-12 max-w-lg space-y-6 font-sans text-base font-light leading-relaxed text-charcoal/75">
            <p>
              Human Design помогает увидеть индивидуальную механику
              человека — то, как он взаимодействует с миром, принимает
              решения и проживает свою энергию.
            </p>
            <p>
              На консультации мы не пытаемся изменить вас. Мы исследуем
              то, что уже есть внутри, чтобы вам было легче опираться
              на себя.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
